import {CallJs} from "../lib/types"
import * as React from "react"
import * as ReactDOM from "react-dom"
import {createStore} from "redux"
import {pricesApp, Form as PricingOptionForm} from "./pricing-option-form/app";
import {FinancialCodes, InfoformField, PricingOptionState} from "./pricing-option-form/common/types";
import {CostItem} from "./pricing-option-form/standard-items/types";
import {FieldCostItem} from "./pricing-option-form/field-items/types";

interface PricingOptionCallJsParams {
	standardCostItems:{
		items:CostItem[]
		signupFields:InfoformField[]
		renewFields:InfoformField[]
		autoRenewalEnabled: boolean
	},
	signupFieldCostItems:FieldCostItem[]
	renewFieldCostItems:FieldCostItem[]
	financialCodeLabels: FinancialCodes
}

const reduxStateFromCallJsParams = (params: PricingOptionCallJsParams): PricingOptionState => {
	return {
		standardCostItems:    {
			items:              params.standardCostItems.items,
			signupFields:       params.standardCostItems.signupFields.filter(field => !field.supportsMultiselect),
			renewFields:        params.standardCostItems.renewFields.filter(field => !field.supportsMultiselect),
			autoRenewalEnabled: params.standardCostItems.autoRenewalEnabled,
		},
		signupFieldCostItems: params.signupFieldCostItems,
		renewFieldCostItems:  params.renewFieldCostItems,
	};
}

export const CostItemForm: CallJs<PricingOptionCallJsParams> = (callback, params) => {
	const div = document.createElement("div")
	callback(div)
	const store = createStore<PricingOptionState>(pricesApp, reduxStateFromCallJsParams(params))
	ReactDOM.render(<PricingOptionForm labels={params.financialCodeLabels} store={store}/>, div)
}



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form.tsx